// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import {
    getVsrMessageForClaimItem,
    hasVsrErrorForClaimItem
} from '../../services/claim-shared-helper';
import ClaimLabor from '@deere/cps-it.warranty-model-factory/lib/claim-item-labor';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import LaborsPanelRowBody from './labors-panel-row-body';
import LaborsPanelRowHeader from './labors-panel-row-header';
import NonEditableLaborPanel from './non-editable-labor-panel';
import {buildNumber} from '../../../../shared/services/build-number';

function handleDelete(index) {

    this.onDelete(index);

}

function handleLocationChange(index, partNumber) {

    this.onLocationChange(index, partNumber);

}

function handleTypeChange(index, partNumber) {

    this.onTypeChange(index, partNumber);

}

function handleTechIdChange(index, techId) {

    this.onTechIdChange(index, techId);

}

function handleHoursChange(index, hours) {

    const value = hours ? parseFloat(hours) : null;

    this.onHoursChange(index, value);

}

function handleLaborCommentsChange(index, laborComments) {

    this.onLaborCommentsChange(index, laborComments);

}

const getEditable = props =>
    props.labors.map((labor, index) =>
        <LaborsPanelRowBody
            highlightClass={hasVsrErrorForClaimItem(props.errors, 'LABOR', labor.lineNumber)}
            isEditable={props.isEditable}
            key={index}
            labor={labor}
            laborLocations={props.laborLocations}
            laborTypes={props.laborTypes}
            numberOfLabors={props.labors.length}
            onDelete={handleDelete.bind(props, index)}
            onHoursChange={handleHoursChange.bind(props, index)}
            onLaborCommentsChange={handleLaborCommentsChange.bind(props, index)}
            onLocationChange={handleLocationChange.bind(props, index)}
            onTechIdChange={handleTechIdChange.bind(props, index)}
            onTypeChange={handleTypeChange.bind(props, index)}
            vsrMessage={getVsrMessageForClaimItem(props.errors, 'LABOR', labor.lineNumber)}
        />
    );

const getNonEditable = props =>
    props.labors.map((labor, index) =>
        <NonEditableLaborPanel
            key={index}
            labor={labor}
        />
    );

const LaborsPanel = props =>
    <section className='labor-panel'>
        <h3 className='labor-panel-title'>
            <FormattedMessage
                id='LABOR_WITH_COUNT'
                values={{
                    count: buildNumber(props.labors.length)
                }}
            />
        </h3>
        {props.isEditable &&
            <LaborsPanelRowHeader/>
        }
        <section className='labor-list'>
            {props.isEditable ?
                getEditable(props) :
                getNonEditable(props)
            }
        </section>
        {props.isEditable &&
            <button
                className='add-labor-icon-button'
                onClick={props.onCreate}
            />
        }
    </section>;

LaborsPanel.displayName = 'LaborsPanel';
LaborsPanel.propTypes = {
    errors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)),
    isEditable: PropTypes.bool.isRequired,
    laborLocations: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    laborTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    labors: PropTypes.arrayOf(PropTypes.instanceOf(ClaimLabor)).isRequired,
    onCreate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    onHoursChange: PropTypes.func.isRequired,
    onLaborCommentsChange: PropTypes.func.isRequired,
    onLocationChange: PropTypes.func.isRequired,
    onTechIdChange: PropTypes.func.isRequired,
    onTypeChange: PropTypes.func.isRequired
};

export default LaborsPanel;



// WEBPACK FOOTER //
// ./src/claim/shared/components/labors-panel/index.js